import React, { useEffect, useState } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { default as AdminWrapper } from "lib/scaffolding/AdminWrapper"
import { AppProvider, AppStoreProvider } from "lib/state"
import { DisputeElementManager, DisputeLayout, DisputeList, DisputePreview, DisputeSetup, DisputeWrapper } from "lib/units/dispute";
import { default as TemplateWrapper } from "lib/units/template/TemplateWrapper"
import { default as SetupWrapper } from "lib/units/template/setup/SetupWrapper"
import { default as BuilderWrapper } from "lib/units/template/build/BuilderWrapper"
import { default as PreviewWrapper } from "lib/units/template/preview/PreviewWrapper"
import { ClientProvider } from "pages/clients"
import { ConditionalsPage } from "pages/conditionals"
import { ContentPage } from "pages/content"
import { DesignProvider } from "pages/designs"
import { LayoutProvider } from "pages/layouts"
import { UserProvider } from "pages/users"
import { default as RulesEnginePage } from "pages/rules/RulesEnginePage"
import { CodeRunner, DevtoolsProvider, MigrateDisputes, ComparisonTool } from "pages/devtools"
import { default as LoginPage } from "lib/scaffolding/Login"
import { TemplateList } from "lib/units/template/list"
import { MidmetricsEditor } from "lib/units/mmedit"
import GeneratePDF from "lib/pdf/GeneratePDF"
import { randoms } from "lib/utils"

import "./lib/vendors/tailwind/global.css"

const queryClient = new QueryClient();

export function App() {
  const [ showDevTools, setShowDevTools ] = useState<any>(true)

  useEffect(() => {
    if( window.location.href.includes("/pdf/") ){
      setShowDevTools(false)
    }
  },[window.location.href])


  return (
    <QueryClientProvider client={queryClient}>
      { showDevTools && <ReactQueryDevtools initialIsOpen={false} /> }
      <AppProvider>
        <AppStoreProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginPage/>} />
              <Route path="/midmetrics" element={<MidmetricsEditor />} />
              <Route path="/pdf/:dspid" element={<GeneratePDF/>} />
              
              <Route element={<AdminWrapper/>}>
                <Route path="/client/:cid?" element={<ClientProvider/>} />
                <Route path="/conditional/:ctid?" element={<ConditionalsPage/>} />
                <Route path="/content" element={<ContentPage/>} />
                <Route path="/design/:desid?" element={<DesignProvider/>} />
                <Route path="/layout/:layid?" element={<LayoutProvider/>} />
                <Route path="/rules" element={<RulesEnginePage/>} />
                <Route path="/user/:uid?" element={<UserProvider/>} /> 

                <Route path="/devtools" element={<DevtoolsProvider/>} />
                <Route path="/devtools/migrator" element={<MigrateDisputes />} />
                <Route path="/devtools/comparison" element={<ComparisonTool />} />
                <Route path="/devtools/coderunner" element={<CodeRunner />} />

                <Route path="/template" element={<TemplateList/>} />

                <Route path="/template/:tmplid" element={<TemplateWrapper/>}>
                  <Route path="/template/:tmplid/setup" element={<SetupWrapper/>} />
                  <Route path="/template/:tmplid/build" element={<BuilderWrapper/>} />
                  <Route path="/template/:tmplid/preview" element={<PreviewWrapper/>} />
                </Route>

                <Route path="/dispute/:dspid?" element={<DisputeWrapper/>}>
                  <Route path="/dispute/:dspid/setup" element={<DisputeSetup />} />
                  <Route path="/dispute/:dspid/config" element={<DisputeLayout/>} />
                  <Route path="/dispute/:dspid/preview" element={<DisputePreview/>} />
                  <Route path="/dispute/:dspid/element" element={<DisputeElementManager/>} />
                </Route>
              </Route>
              
            </Routes>
          </BrowserRouter>
        </AppStoreProvider>
      </AppProvider>
    </QueryClientProvider>
  )


}